export default __webpack_public_path__ + "static/media/book_session.d8f2f342.png";